<div style="display: flex; align-items: center; position: relative">
    <ng-content select="ai-label"></ng-content>
    <ng-content select="ai-icon"></ng-content>

    <input
        class="ai-text-input {{ cssClass() }}"
        [class.ai-text-input--with-counter]="showCharacterCount() && maxLength() != null"
        [class.ai-text-input--invalid]="isInvalid()"
        type="text"
        [attr.maxlength]="maxLength() != null ? maxLength() : null"
        [formControl]="ngControl.control"
        [placeholder]="placeholder()"
    />

    @if (showCharacterCount() && maxLength() != null) {
        <span class="ai-text-input__counter">{{ currentLength }}/{{ maxLength() }}</span>
    }

    <div
        class="ai-text-input__adornments"
        style="
            display: flex;
            align-items: center;
            gap: 6px;
            position: absolute;
            right: 10px;
        "
    >
        @if (isInvalid()) {
            <ai-icon
                class="ai-text-input__error-icon"
                [fontIcon]="'fa-solid fa-circle-exclamation'"
            />
        }

        <ai-button
            *ngFor="let action of actions()"
            [disabled]="ngControl.disabled ?? false"
            [border]="'hidden'"
            [type]="'button'"
            [transparent]="true"
            (click)="onActionButtonClicked($event, action)"
        >
            <ai-icon [fontIcon]="action.fontIcon" />
        </ai-button>
    </div>
    <ng-content select="ai-message"></ng-content>
</div>
